var table_viewer_default = {
  "viewMode": "bkNIp",
  "editMode": "I1XKJ",
  "container": "AHfdz",
  "cell": "oqR9Y"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
